import { React } from 'react';

function MembershipSubscription() {
    return (
        <div>
            <div className="int-container">
                <div class="container">
                    <div class="form-container-large" style={{ width: "100%" }}>
                        <div class="form-group">
                            <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Membership Subscription </h3>
                        </div>
                        <div class="col-md-4 form-group">
                            <div class="member-card">
                                <h4 class="text-center">Free trial for</h4>
                                <h5 class="text-center">7 days</h5>
                            </div>
                        </div>
                        <div class="col-md-4 form-group">
                            <div class="member-card">
                                <h4 class="text-center">3 Month Plan</h4>
                                <h5 class="text-center">$180</h5>
                            </div>
                        </div>
                        <div class="col-md-4 form-group">
                            <div class="member-card">
                                <h4 class="text-center">1 year Plan</h4>
                                <h5 class="text-center">$650</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MembershipSubscription;